module.exports = "/_next/static/images/02b7627d7b0e2a21fb76c4182eac4212-man-looking-up-smiling-lg@3x.jpg.webp";